<ng-container *ngIf="(!loadingCalendar || isDesktop) && (currentUser.adminRole || !currentUser.isContractor)">
    <div class="extra-buttons">
        <div class="approve-days-block">
            <button mat-button (click)="requestVactions()" class="approve-day">Request PTO</button>
            <button mat-button (click)="approveSelectedDays()" class="approve-day"
                    [disabled]="choosenDaysMap.size === 0 || approveLoading"
                    [ngClass]="{'disabled-button': choosenDaysMap.size === 0 || rejectLoading}">Approve</button>
            <button mat-button (click)="rejectSelectedDays()" class="approve-day"
                    [disabled]="choosenDaysMap.size === 0 || rejectLoading"
                    [ngClass]="{'disabled-button': choosenDaysMap.size === 0 || rejectLoading}">Reject</button>
        </div>
        <div class="print-button-block">
            <button mat-button (click)="generatePdf()" class="approve-day">PTO Report</button>
        </div>
    </div>
</ng-container>

<full-calendar #vfc [options]="options"></full-calendar>


<p-overlayPanel #holidayOp styleClass="overlay-panel holiday-panel">
	{{holidayStr}}
</p-overlayPanel>


<p-confirmDialog appendTo="body" icon="pi pi-check" styleClass="calendar-panel">
  <textarea></textarea>
</p-confirmDialog>


<!-- <div class="loading-screen" *ngIf="loadingEvents">
	<lib-progress-spinner></lib-progress-spinner>
</div> -->
